import { dfpConst, adDevice } from './const';

export const removeSlot = function () {
  if (window) {
    const { googletag } = window
    googletag?.cmd?.push(function () {
      googletag?.destroySlots()
    })
  }
};

export const defineSlot = function (name, id, sizes = [], params = {}) {
  if (window) {
    const { googletag, lotaudsList, screen } = window
    googletag?.defineSlot && googletag?.defineSlot(`/${dfpConst.slot_id}/${name}`, sizes, id).addService(googletag.pubads())
    googletag?.pubads && googletag?.pubads().setTargeting('section', params.section).setTargeting('position', params.position)
    googletag?.pubads && googletag?.pubads().enableSingleRequest(false)
  }
};

export const enableServices = function (id) {
  if (window) {
    const { googletag } = window
    googletag?.enableServices && googletag?.enableServices()
  }
};

export const displayId = function (id) {
  if (window) {
    const { googletag } = window
    googletag?.display && googletag?.display(id)
  }
};



